import React from "react";

// Tiny dependency-free SVG sparkline. `series` = [{ day, n }]. Bars-free line + area, last point highlighted.
export default function Sparkline({ series = [], width = 140, height = 32, stroke = "#264839", fill = "rgba(38,72,57,0.12)", testId }) {
  const vals = series.map((p) => Number(p.n) || 0);
  const n = vals.length;
  if (!n) return null;
  const max = Math.max(1, ...vals);
  const stepX = n > 1 ? width / (n - 1) : width;
  const pts = vals.map((v, i) => [i * stepX, height - 2 - (v / max) * (height - 6)]);
  const d = pts.map(([x, y], i) => `${i ? "L" : "M"}${x.toFixed(1)},${y.toFixed(1)}`).join(" ");
  const area = `${d} L${(width).toFixed(1)},${height} L0,${height} Z`;
  const [lx, ly] = pts[n - 1];
  const total = vals.reduce((a, b) => a + b, 0);
  const title = `${total} click${total === 1 ? "" : "s"} in the last ${n} days · peak ${max}/day`;
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className="overflow-visible" role="img" aria-label={title} data-testid={testId} data-total={total}>
      <title>{title}</title>
      <path d={area} fill={fill} />
      <path d={d} fill="none" stroke={stroke} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={lx} cy={ly} r="2.5" fill={stroke} />
    </svg>
  );
}
